/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
module.exports = function loadCSSBundle(bundle) {
  var pathname = new URL(bundle).pathname;
  var newSrc = window._srp.resourceURL ? new URL(pathname, window._srp.resourceURL) : bundle;
  return (window._srp && window._srp.fallbackLocations || []).reduce((previousPromise, nextFallback) => {
    return previousPromise.catch(() => {
      var metricsObj = {
        fileName: pathname,
        oldOrigin: window._srp.resourceURL,
        newOrigin: nextFallback,
        assetType: 'dynamic_asset'
      };
      window._srp.fallbackMetrics(metricsObj);
      window._srp.resourceURL = nextFallback;
      newSrc = new URL(pathname, nextFallback);
      return Promise.resolve(origLoadCSSBundle(newSrc));
    });
  }, Promise.resolve(origLoadCSSBundle(newSrc)));
}

function origLoadCSSBundle(bundle) {
  return new Promise(function (resolve, reject) {
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = bundle;
    link.onerror = function (e) {
      link.onerror = link.onload = null;
      reject(e);
    };

    link.onload = function () {
      link.onerror = link.onload = null;
      resolve();
    };

    document.getElementsByTagName('head')[0].appendChild(link);
  });	
};